export default __webpack_public_path__ + "static/media/weixinqrcode.3e09d641.png";